import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=4f81d070&scoped=true&"
import script from "./PaymentForm.vue?vue&type=script&lang=js&"
export * from "./PaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=4f81d070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81d070",
  null
  
)

export default component.exports